/**
 * Everlast page session logging — sends events to a configurable API endpoint.
 * Default endpoint: https://api.neveneyewear.com/api/frontend-logs (POST)
 * Override via window.EVERLAST_LOG_ENDPOINT or EverlastLogger.init(url).
 * Every payload includes source: "everlast" (filter alongside rx_form on the same endpoint).
 */
(function () {
  var STORAGE_KEY = 'everlastSessionId';
  var SOURCE = 'everlast';

  function isEverlastPage() {
    return window.location.pathname.indexOf('everlast') !== -1;
  }

  function generateUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getSessionId() {
    try {
      var id = sessionStorage.getItem(STORAGE_KEY);
      if (!id) {
        id = generateUuid();
        sessionStorage.setItem(STORAGE_KEY, id);
      }
      return id;
    } catch (e) {
      return generateUuid();
    }
  }

  function getEndpoint() {
    return (window.EVERLAST_LOG_ENDPOINT || '').trim();
  }

  function safeClone(value) {
    if (value == null) return value;
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (e) {
      return String(value);
    }
  }

  function getMetafieldsSnapshot() {
    return {
      everlast_dom_variant_metafields:
        typeof everlast_dom_variant_metafields !== 'undefined'
          ? safeClone(everlast_dom_variant_metafields)
          : null,
      everlast_intl_variant_metafields:
        typeof everlast_intl_variant_metafields !== 'undefined'
          ? safeClone(everlast_intl_variant_metafields)
          : null,
    };
  }

  function getEverlastStateSnapshot() {
    return typeof everlastState !== 'undefined' ? safeClone(everlastState) : null;
  }

  function trimValue(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function getPromotedIdentity(mergedPayload) {
    var email = '';
    var orderNumber = '';
    var state =
      (mergedPayload && mergedPayload.everlastState) ||
      (typeof everlastState !== 'undefined' ? everlastState : null);
    var data = mergedPayload && mergedPayload.data;

    if (state && state.email) email = trimValue(state.email);
    if (state && state.selectedOrderName) orderNumber = trimValue(state.selectedOrderName);

    if (typeof orderNumberState !== 'undefined' && orderNumberState) {
      orderNumber = orderNumber || trimValue(orderNumberState);
    }

    if (data) {
      if (!email && data.email) email = trimValue(data.email);
      if (!orderNumber && data.orderNumber) orderNumber = trimValue(data.orderNumber);
      if (!orderNumber && data.orderName) orderNumber = trimValue(data.orderName);
      if (!orderNumber && data.amazonOrderId) orderNumber = trimValue(data.amazonOrderId);
      if (!orderNumber && data.tiktokOrderId) orderNumber = trimValue(data.tiktokOrderId);
    }

    var emailEl = document.getElementById('email-address');
    var orderEl = document.getElementById('textfield-neven-order-number');
    var selectOrderEl = document.getElementById('select-neven-order-number');
    var amazonEl = document.getElementById('textfield-amazon-order-id');
    var tiktokEl = document.getElementById('textfield-tiktok-order-id');

    if (!email && emailEl && emailEl.value) email = trimValue(emailEl.value);
    if (!orderNumber && selectOrderEl && selectOrderEl.value) {
      orderNumber = trimValue(selectOrderEl.value);
    }
    if (!orderNumber && orderEl && orderEl.value) orderNumber = trimValue(orderEl.value);
    if (!orderNumber && amazonEl && amazonEl.value) orderNumber = trimValue(amazonEl.value);
    if (!orderNumber && tiktokEl && tiktokEl.value) orderNumber = trimValue(tiktokEl.value);

    var promoted = {};
    if (email) promoted.email = email;
    if (orderNumber) promoted.orderNumber = orderNumber;
    return promoted;
  }

  function buildBasePayload() {
    return {
      source: SOURCE,
      sessionId: getSessionId(),
      timestamp: new Date().toISOString(),
      everlastState: getEverlastStateSnapshot(),
      everlast_dom_variant_metafields: getMetafieldsSnapshot().everlast_dom_variant_metafields,
      everlast_intl_variant_metafields: getMetafieldsSnapshot().everlast_intl_variant_metafields,
    };
  }

  function tryParseBody(body) {
    if (body == null) return undefined;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        if (body.length > 2000) return body.substring(0, 2000) + '…[truncated]';
        return body;
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return '[FormData]';
    }
    return body;
  }

  function summarizeResponseBody(text, contentType) {
    if (!text) return null;
    if (contentType && contentType.indexOf('application/json') !== -1) {
      try {
        return JSON.parse(text);
      } catch (e) {
        return text.substring(0, 500);
      }
    }
    if (text.length > 500) {
      return { preview: text.substring(0, 500), truncated: true, length: text.length };
    }
    return text;
  }

  function getApiErrorFromBody(body) {
    if (!body || typeof body !== 'object') return null;
    if (body.success === false || body.success === 'error') {
      return (
        body.message ||
        (typeof body.error === 'string' ? body.error : null) ||
        (body.errors ? String(body.errors) : null) ||
        'API returned success: false'
      );
    }
    return null;
  }

  function resolveApiErrorMessage(summary) {
    if (!summary) return null;
    if (summary.error) return summary.error;
    if (summary.ok === false) {
      return summary.statusText || 'HTTP ' + (summary.status || 'error');
    }
    return getApiErrorFromBody(summary.body);
  }

  var LOG_REQUEST_TIMEOUT_MS = 5000;

  /** Never throws; never blocks callers — logging must not affect Everlast UX. */
  function sendLog(payload) {
    try {
      if (!isEverlastPage()) return;
      var endpoint = getEndpoint();
      if (!endpoint) return;

      var body = Object.assign({}, buildBasePayload(), payload);
      Object.assign(body, getPromotedIdentity(body));

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = controller
        ? setTimeout(function () {
            controller.abort();
          }, LOG_REQUEST_TIMEOUT_MS)
        : null;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        signal: controller ? controller.signal : undefined,
      })
        .catch(function () {
          /* intentionally silent */
        })
        .finally(function () {
          if (timeoutId) clearTimeout(timeoutId);
        });
    } catch (e) {
      /* payload build or stringify failed — ignore */
    }
  }

  window.EverlastLogger = {
    isEverlastPage: isEverlastPage,
    getSessionId: getSessionId,

    init: function (endpoint) {
      if (endpoint) window.EVERLAST_LOG_ENDPOINT = endpoint;
      getSessionId();
      sendLog({
        event: 'page_load',
        action: 'everlast_page_loaded',
        data: {
          url: window.location.href,
          search: window.location.search,
          referrer: document.referrer || null,
        },
      });
    },

    log: function (event, action, data) {
      sendLog({
        event: event,
        action: action,
        data: data || {},
      });
    },

    logInteraction: function (action, data) {
      this.log('user_interaction', action, data);
    },

    logApiRequest: function (action, url, options) {
      sendLog({
        event: 'api_request',
        action: action,
        data: {
          url: url,
          method: (options && options.method) || 'GET',
          body: options ? tryParseBody(options.body) : undefined,
        },
      });
    },

    logApiResponse: function (action, url, summary) {
      try {
        var data = Object.assign({ url: url }, summary || {});
        var errorMessage = resolveApiErrorMessage(summary);

        if (errorMessage) {
          data.errorMessage = errorMessage;
          sendLog({ event: 'api_error', action: action, data: data });
          return;
        }

        sendLog({ event: 'api_response', action: action, data: data });
      } catch (e) {
        /* ignore */
      }
    },

    /**
     * Wraps fetch for Everlast page API calls — logs in the background only.
     */
    trackedFetch: async function (action, url, options) {
      options = options || {};
      this.logApiRequest(action, url, options);

      try {
        var response = await fetch(url, options);
        var contentType = response.headers.get('content-type') || '';
        var clone = response.clone();
        var summary = { ok: response.ok, status: response.status };

        try {
          var text = await clone.text();
          summary.body = summarizeResponseBody(text, contentType);
        } catch (readErr) {
          summary.body = null;
          summary.readError = readErr.message || String(readErr);
        }

        this.logApiResponse(action, url, summary);
        return response;
      } catch (err) {
        this.logApiResponse(action, url, {
          ok: false,
          error: err.message || String(err),
        });
        throw err;
      }
    },

    bindFormInputLogging: function (formSelector) {
      var form = document.querySelector(formSelector);
      if (!form) return;

      var debounceTimers = {};

      form.addEventListener(
        'input',
        function (e) {
          var target = e.target;
          if (!target || !target.matches('input, select, textarea')) return;

          var key = target.id || target.name || 'unknown';
          clearTimeout(debounceTimers[key]);
          debounceTimers[key] = setTimeout(function () {
            EverlastLogger.logInteraction('form_input', {
              fieldId: target.id || null,
              fieldName: target.name || null,
              fieldType: target.type || target.tagName.toLowerCase(),
              value: target.value,
            });
          }, 600);
        },
        true
      );

      form.addEventListener(
        'change',
        function (e) {
          var target = e.target;
          if (!target || !target.matches('select')) return;
          EverlastLogger.logInteraction('form_select_change', {
            fieldId: target.id || null,
            fieldName: target.name || null,
            value: target.value,
          });
        },
        true
      );
    },
  };
})();
